import { Component } from '@angular/core';
import { ACDATAConnectorPanel } from '../a.cdata.connector.panel';
import { CDATAConnectorInfo } from '../../../../../../../models/datamodel/adbinfo.model';

@Component({
    selector: 'sapb1-connector-panel',
    templateUrl: './sapb1.connector.panel.html'
})
export class SAPB1ConnectorPanel extends ACDATAConnectorPanel {
    static GetInfo(): CDATAConnectorInfo {
        return {
            Caption: '@@SAP Business One',
            Type: 'evidanza.Database.CData.CDataConnector.ConnectorsInfo.SAPB1Info',
            ControlType: SAPB1ConnectorPanel,
            Default: null
        };
    }
}
